/**/
/*open user dropdown menu*/
(function($, window, document) {
    $(document).ready(function() {
        var $lkDropdownWrap = $('.lk-dropdown-wrap');

        if ($lkDropdownWrap.length === 0) {
            return
        }

        var $dropdown = $('.dropdownUserMenu');
        var mobileWidth = 992;

        $lkDropdownWrap.bind('mouseenter', function() {
            if (window.innerWidth > mobileWidth) {
                if (!$dropdown.hasClass('active')) {
                    $dropdown.addClass('active');
                    $('body').addClass('lk-dropdown-active')
                }
            }
        }).bind('mouseleave', function() {
            if (window.innerWidth > mobileWidth) {
                if ($dropdown.hasClass('active')) {
                    $dropdown.removeClass('active');
                    $('body').removeClass('lk-dropdown-active')
                }
            }
        });
    });
})(jQuery, window, document);

